import React, { Component } from "react";
import Bridge from "../../utils/Bridge";
import { Spin } from "antd";

export default class SpeechAboutMe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_visible_first_step: false,
      loading: false,
      non_als_user: false,
    };
  }
  componentDidMount() {
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({ loading: true });
    let params =
      "?participants_accounts_id=" +
      localStorage.getItem("ap_participants_accounts_id");
    Bridge.demographics.speech
      .check_als_user(params)
      .then((response) => {
        if (response.status == "1") {
          this.setState({
            is_visible_first_step: response.data.non_als_user,
            percentage: response.data.percentage,
            loading: false,
            non_als_user: response.data.non_als_user,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <Spin spinning={this.state.loading}>
        <div>
          {this.state.non_als_user == true && (
            <div className="single-account">
              <a
                href="/speech-non-als-users"
                style={{ textDecoration: "none" }}
              >
                <div className="block">
                  <div className="d-flex align-items-center">
                    <h4 className="mb-0 pb-0">Non-Als Users</h4>
                  </div>
                  <a href="/speech-non-als-users" className="update-button">
                    NEXT{" "}
                    <box-icon
                      name="chevron-right"
                      color="#fff"
                      style={{ position: "relative", top: 0 }}
                    ></box-icon>
                  </a>
                </div>
              </a>
            </div>
          )}
          <div className="single-account">
            <a href="/speech-date-of-birth" style={{ textDecoration: "none" }}>
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">Date of Birth and Sex</h4>
                </div>
                <a href="/speech-date-of-birth" className="update-button">
                  NEXT{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
          <div className="single-account">
            <a
              href="/speech-ethnicity-and-race"
              style={{ textDecoration: "none" }}
            >
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">Ethnicity and Race</h4>
                </div>
                <a href="/speech-ethnicity-and-race" className="update-button">
                  NEXT{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
          <div className="single-account">
            <a
              href="/speech-language-and-education"
              style={{ textDecoration: "none" }}
            >
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">Language and Education</h4>
                </div>
                <a
                  href="/speech-language-and-education"
                  className="update-button"
                >
                  NEXT{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
          <div className="single-account">
            <a
              href="/speech-handness-and-smoking-history"
              style={{ textDecoration: "none" }}
            >
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">
                    {" "}
                    Handedness and Smoking History{" "}
                  </h4>
                </div>
                <a
                  href="/speech-handness-and-smoking-history"
                  className="update-button"
                >
                  NEXT{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
          <div className="single-account">
            <a
              href="/speech-allergies-and-prescriptions"
              style={{ textDecoration: "none" }}
            >
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0"> Allergies and Prescriptions </h4>
                </div>
                <a
                  href="/speech-allergies-and-prescriptions"
                  className="update-button"
                >
                  NEXT{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
          <div className="single-account">
            <a
              href="/speech-medical-history"
              style={{ textDecoration: "none" }}
            >
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">Medical History</h4>
                </div>
                <a href="/speech-medical-history" className="update-button">
                  NEXT{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
          {this.state.non_als_user == false && (
            <div className="single-account">
              <a href="/speech-diagnosis" style={{ textDecoration: "none" }}>
                <div className="block">
                  <div className="d-flex align-items-center">
                    <h4 className="mb-0 pb-0"> Diagnosis </h4>
                  </div>
                  <a href="/speech-diagnosis" className="update-button">
                    NEXT{" "}
                    <box-icon
                      name="chevron-right"
                      color="#fff"
                      style={{ position: "relative", top: 0 }}
                    ></box-icon>
                  </a>
                </div>
              </a>
            </div>
          )}
          {this.state.non_als_user == false && (
            <div className="single-account">
              <a
                href="/speech-symptom-onset"
                style={{ textDecoration: "none" }}
              >
                <div className="block">
                  <div className="d-flex align-items-center">
                    <h4 className="mb-0 pb-0"> Symptom Onset </h4>
                  </div>
                  <a href="/speech-symptom-onset" className="update-button">
                    NEXT{" "}
                    <box-icon
                      name="chevron-right"
                      color="#fff"
                      style={{ position: "relative", top: 0 }}
                    ></box-icon>
                  </a>
                </div>
              </a>
            </div>
          )}
          <div className="single-account">
            <a href="/speech-family-history" style={{ textDecoration: "none" }}>
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">Family History</h4>
                </div>
                <a href="/speech-family-history" className="update-button">
                  NEXT{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
        </div>
      </Spin>
    );
  }
}
